import type { Components } from '@mui/material'

export const MuiAccordionDetails: Components['MuiAccordionDetails'] = {
  styleOverrides: {
    root: {
      padding: 0,
    },
  },
}
